import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const LayoutOnboardingPagesWrapper = styled.div`
  @media (max-width: 768px) {
    padding: 1rem 1rem 11rem 1rem;
    header {
      width: 100% !important;
    }
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  header {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 70%;
    margin: 20px auto;

    img {
      // position: absolute;
      // left: 0px;
      // top: 0px;
    }

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  h1 {
    /* max-width: 80%; */
    font-size: 1.5em;
    font-weight: 700;
    text-align: center;
  }

  h2 {
    /* width: 70%;
    font-size: 29px;
    line-height: 34px;
    font-weight: 300; */

    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 48px;
    width: 70%;
    line-height: 56px;
  }

  h3 {
    font-size: 1.8em;
    text-align: left;
  }

  .is-valid {
    color: #4b997c;
    background-color: #d8f6ed;
  }

  .check-tag {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    border-radius: 20px;
    margin: 20px 5px;
  }
  .check-tag > * {
    font-size: 14px;
  }

  .left-illus {
    display: none;
  }

  .ant-input {
    height: 50px !important;
    display: block;
    font-size: 16px;
    width: 100%;
    font-weight: 500;
    letter-spacing: 0.6px;

    &-affix-wrapper {
      > .ant-input {
        height: 50px !important;
      }
      border-radius: 8px;
    }
  }

  input[name='email'] {
    height: 60px !important;
  }

  .ant-btn {
    width: 100%;
  }

  label {
    font-size: 14px;
  }

  .forgotLink {
    cursor: pointer;
    color: #40a9ff;
    text-decoration: underline;
    text-align: center;
    width: 100%;
    display: block;
    font-size: 14px;
    margin-top: 1rem;
  }

  .inputError {
    position: absolute;
    color: #dc3545;
    font-weight: 600;
    font-size: 12px;
  }

  @media (min-width: 768px) {
    .container-form {
      // width: 70%;
    }
  }

  @media (min-width: 1024px) {
    flex-direction: row;

    .container-form {
      width: 70%;
      height: 100vh;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .left-illus {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      height: 100vh;
      position: relative;
      overflow: hidden;
      background-size: cover;
      background-repeat: no-repeat;
    }

    .left-illus::after {
      content: '';
      position: absolute;
      height: 100vh;
      width: 110px;
      right: 0px;
      bottom: 0px;
      background: #fafafa;
      clip-path: ellipse(41% 52% at 106% 50%);
    }
  }
`
